/* Science hub (sections/science-hub.liquid): decorative background video for the closing block.
   - Nothing loads until the block is within 400px of the viewport (the video has no src and preload none).
   - It never autoplays under prefers-reduced-motion or Save-Data; the poster image stays, and the
     button offers play instead.
   - The pause button (WCAG 2.2.2) is shown by this script, so without script there is only the poster.
   - Off screen the video pauses; it resumes on return unless the visitor paused it.
   - If the file fails (network, codec), the poster stays and the button is withdrawn: nothing moves, so
     there is nothing to control.
   - Safe to run twice: each block is set up once, and the theme editor's section reload sets up the new one. */
(function () {
  function init(root) {
    root.querySelectorAll('.sci-vcta').forEach(function (block) {
      if (block.dataset.sciVcta) return;
      var video = block.querySelector('video'), toggle = block.querySelector('.sci-vcta__toggle');
      if (!video || !toggle || !video.dataset.src) return;
      block.dataset.sciVcta = 'ready';
      var reduce = matchMedia('(prefers-reduced-motion: reduce)');
      var saveData = !!(navigator.connection && navigator.connection.saveData);
      var userPaused = false, inView = false, failed = false;

      function setState(playing) {
        toggle.dataset.state = playing ? 'playing' : 'paused';
        toggle.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
      }
      function play() {
        if (failed) return;
        if (!video.getAttribute('src')) { video.src = video.dataset.src; }
        video.muted = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () { setState(false); });
      }

      video.addEventListener('playing', function () { block.classList.add('is-playing'); setState(true); });
      video.addEventListener('pause', function () { setState(false); });
      video.addEventListener('error', function () {
        failed = true; block.classList.remove('is-playing'); toggle.hidden = true;
      });
      toggle.addEventListener('click', function () {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
      });
      reduce.addEventListener('change', function () {
        if (reduce.matches && !video.paused) { userPaused = true; video.pause(); }
      });

      setState(false);
      toggle.hidden = false;
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView && !userPaused && !reduce.matches && !saveData) play();
          else if (!inView && !video.paused) video.pause();
        });
      }, { rootMargin: '400px 0px' }).observe(block);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
